import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import DirectionsIcon from '@mui/icons-material/Directions';
import * as React from 'react';
import LinkTile from './LinkTile';
import SettingsGroup from './SettingsGroup';

interface AssessmentSettingsProps {
  linkIconTileClassName: string;
}

const AssessmentSettings = ({
  linkIconTileClassName,
}: AssessmentSettingsProps) => {
  return (
    <SettingsGroup title="Assessments">
      <LinkTile href="/beacon/administrations" text="Manage Administrations">
        <AssignmentIcon className={linkIconTileClassName} />
      </LinkTile>
      <LinkTile
        href="/beacon/settings/customquestionbank/edit"
        text="Custom Question Library"
      >
        <DescriptionIcon className={linkIconTileClassName} />
      </LinkTile>
      <LinkTile
        href="/beacon/settings/recommendations"
        text="Custom Assessment Recommendations"
      >
        <DirectionsIcon className={linkIconTileClassName} />
      </LinkTile>
    </SettingsGroup>
  );
};

export default AssessmentSettings;
